// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2K96t","label":"Completed_label__9BKC1"};